const cards = [
  {
    title: '最新上架：这些好片别错过',
    tag: '新片速递',
    desc: '本周新上架12部高分影视作品，涵盖科幻、悬疑、喜剧等多种类型，总有一部适合你。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20theater%20setup%20with%20large%20screen%20displaying%20vibrant%20movie%20scene%2C%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20cinematic%20atmosphere%2C%20golden%20and%20warm%20tones%2C%20professional%20interior%20photography&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    title: '悬疑片单：烧脑神作大盘点',
    tag: '精选片单',
    desc: '从国产佳作到海外经典，精选20部让你看到停不下来的高分悬疑推理影视作品。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20library%20with%20warm%20desk%20lamp%20lighting%2C%20open%20books%20and%20magnifying%20glass%20on%20wooden%20table%2C%20shadowy%20bookshelves%20in%20background%2C%20detective%20atmosphere%2C%20rich%20brown%20and%20gold%20tones%2C%20cinematic%20lighting&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    title: '周末追剧指南：通宵必看',
    tag: '追剧攻略',
    desc: '精选8部节奏紧凑、剧情上头的热播剧，从第一集就停不下来，周末刷剧最佳选择。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20scene%20with%20laptop%20on%20bed%20playing%20movie%2C%20fairy%20lights%20in%20background%2C%20soft%20blankets%2C%20warm%20evening%20atmosphere%2C%20snacks%20nearby%2C%20relaxed%20weekend%20vibe%2C%20golden%20warm%20lighting&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    title: '国漫崛起：这些作品值得骄傲',
    tag: '国创精选',
    desc: '盘点近年来制作精良、口碑爆棚的国产动画作品，国漫正在用实力讲好中国故事。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20ink%20painting%20style%20animation%20scene%2C%20flowing%20robes%20and%20traditional%20architecture%2C%20ethereal%20clouds%20and%20mountains%2C%20warm%20golden%20and%20jade%20green%20accents%2C%20artistic%20composition%2C%20soft%20lighting&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    title: '韩剧精选：高分必看推荐',
    tag: '海外剧场',
    desc: '从治愈甜剧到悬疑烧脑，精选近两年评分最高的韩剧作品，每一部都值得反复观看。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20style%20scene%20with%20cherry%20blossoms%2C%20couple%20walking%20on%20tree-lined%20path%2C%20soft%20pastel%20color%20palette%2C%20warm%20spring%20lighting%2C%20dreamy%20atmosphere%2C%20cinematic%20photography%2C%20emotional%20mood&width=600&height=400&seq=cards-05&orientation=landscape',
  },
  {
    title: '纪录片推荐：看见真实世界',
    tag: '纪录精选',
    desc: '精选10部高分纪录片，从自然奇观到人文历史，带你看见不一样的世界与故事。',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20vast%20natural%20landscape%20with%20mountains%20and%20rivers%2C%20golden%20hour%20sunlight%2C%20drone%20photography%20style%2C%20documentary%20aesthetic%2C%20rich%20earthy%20tones%2C%20breathtaking%20vista%2C%20professional%20nature%20photography&width=600&height=400&seq=cards-06&orientation=landscape',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑团队用心挑选的精彩内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200 group cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}